<!-- Pug Template -->
<template lang="pug">
.list-article-sponsor(
  @click="conversion"
)
  a.list-article-sponsor__heading(
    :href="sponsor.website"
    target="_blank"
  )
    .list-article-sponsor__img-ct
      img.list-article-sponsor__img(
        :alt="sponsor.company"
        :src="sponsor.logo.url"
      )

    h4.list-article-sponsor__heading-text {{ sponsor.company }}

  .list-article-sponsor__links
    a(
      v-if="sponsor.website"
      :href="sponsor.website"
      target="_blank"
    ) Website

    span(
      v-if="sponsor.website && sponsor.email"
    ) |

    a(
      v-if="sponsor.email"
      :href="`mailto:${sponsor.email}`"
      target="_blank"
    ) Email

</template>

<!-- Script -->
<script>
export default {
  props : {
    sponsor: Object
  },

  data(){
    const headingTag = this.sponsor.website ? 'a' : 'div';
    return {
      headingTag
    };
  },

  mounted(){
    setTimeout( () => this.googleEvent('Ad', 'Impression', this.sponsor.company), 2);
  },

  methods: {
    conversion(){
      this.googleEvent('Ad', 'Conversion', this.sponsor.company);
    },

    googleEvent(eventCategory, eventAction, eventLabel){
      if( window.dataLayer ){
        dataLayer.push({
            event: 'gaEvent',
            eventCategory,
            eventAction,
            eventLabel
        });
    }
    }
  }
};
</script>

<!-- SCSS Style -->
<style lang="scss">
@import '../../../scss/front/variables'; 
.list-article-sponsor {
  &__heading {  
    display: block;
    &-text {
      font-size: 1.4rem;
      font-weight: 600;
      @import '../../../scss/front/variables'; 
      color: $color-warm-gray-11;

    }
  }
  &__img-ct {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1em;
  }
  &__img {
    max-width: 100%;
    max-height: 100%;
    &[src$="svg"] {
      width: 100%;
    }
  }

  &__links {
    display: flex;
    justify-content: center;
    font-size: 0.95rem;
    > span {
      margin-left: 0.25em;
      margin-right: 0.25em;
      color: rgba($color-links, 0.45);
    }
  }
}
</style>